import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { WithSideAds } from "components/ads";
import { getHashValue } from "utils";
import { ContentPageSkyscraperEnum } from "../../components/ads/config/units/contentPageSkyscraper";
import { RelatedFeed } from "./components/RelatedFeed";
import { metrics } from "../../utils/metrics";
import { useExperiments } from "hooks/useExperiments";

import "./WatchPage.scss";
import "../common.scss";

export const WatchPage = () => {
  const experiments = useExperiments();

  const { id } = useParams();
  const rel = getHashValue("rel");

  useEffect(() => {
    if (experiments.scroll) {
      metrics.sendExpScrollGroup();
    }
  }, [experiments]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <WithSideAds
      leftAds={[
        ContentPageSkyscraperEnum.ContentPageSkyscraperL1,
      ]}
      rightAds={[
        ContentPageSkyscraperEnum.ContentPageSkyscraperR1,
      ]}
    >
      <div className="page watchPage">
        {id && (
          <RelatedFeed gif={id} rel={rel} className="center" />
        )}
      </div>
    </WithSideAds>
  );
};
